// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2fWhc","right":"styles_right__1-WUR"};